"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.QuestionTypes = void 0;
var QuestionTypes = exports.QuestionTypes = Object.freeze({
  MULTIPLE_CHOICE_QUESTION: 'multipleChoiceQuestionType',
  RATING_QUESTION: 'ratingQuestionType',
  TEXT_QUESTION: 'textQuestionType'
});
var _default = exports["default"] = QuestionTypes;
//# sourceMappingURL=QuestionTypes.js.map